export type UNIXTimestamp = number; // type alias
